// extracted by mini-css-extract-plugin
module.exports = {"likeToggle":"LikeToggle_likeToggle__1NCi-","notActive":"LikeToggle_notActive__cE3Do","active":"LikeToggle_active__3LA0d"};